(() => {
  const slugify = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

  const initArticle = (root) => {
    if (root.dataset.longlashArticleReady === 'true') return;
    root.dataset.longlashArticleReady = 'true';
    const content = root.querySelector('[data-article-content]');
    if (!content) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
    if (headings.length) {
      const used = new Set();
      const items = headings.map((heading, index) => {
        let id = heading.id || slugify(heading.textContent) || `sectiune-${index + 1}`;
        let uniqueId = id;
        let duplicate = 2;
        while (used.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
          uniqueId = `${id}-${duplicate++}`;
        }
        used.add(uniqueId);
        heading.id = uniqueId;
        heading.classList.add('ll-article-anchor');
        return { id: uniqueId, label: heading.textContent.trim(), level: heading.tagName.toLowerCase() };
      });

      root.querySelectorAll('[data-article-toc-list], [data-article-toc-mobile-list]').forEach((list) => {
        items.forEach((item) => {
          const li = document.createElement('li');
          li.className = item.level === 'h3' ? 'is-subheading' : '';
          const link = document.createElement('a');
          link.href = `#${item.id}`;
          link.textContent = item.label;
          li.append(link);
          list.append(li);
        });
      });
      root.querySelector('[data-article-toc]')?.removeAttribute('hidden');
      root.querySelector('[data-article-toc-mobile]')?.removeAttribute('hidden');

      const tocLinks = [...root.querySelectorAll('[data-article-toc-list] a, [data-article-toc-mobile-list] a')];
      const setActive = (activeId) => {
        tocLinks.forEach((link) => {
          if (link.hash === `#${activeId}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      let ticking = false;
      const updateActive = () => {
        const readingLine = Math.min(220, Math.max(130, window.innerHeight * 0.22));
        let activeId = items[0].id;
        for (const item of items) {
          const heading = document.getElementById(item.id);
          if (heading && heading.getBoundingClientRect().top <= readingLine) activeId = item.id;
          else break;
        }
        setActive(activeId);
        ticking = false;
      };

      const requestActiveUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateActive);
      };

      updateActive();
      window.addEventListener('scroll', requestActiveUpdate, { passive: true });
      window.addEventListener('resize', requestActiveUpdate, { passive: true });
      tocLinks.forEach((link) => link.addEventListener('click', () => setActive(link.hash.slice(1))));
    }

    const copyButton = root.querySelector('[data-copy-article-url]');
    copyButton?.addEventListener('click', async () => {
      const original = copyButton.dataset.copyLabel || copyButton.textContent;
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyButton.textContent = copyButton.dataset.copiedLabel || original;
        window.setTimeout(() => { copyButton.textContent = original; }, 1800);
      } catch (_error) {
        const input = document.createElement('input');
        input.value = window.location.href;
        document.body.append(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
    });
  };

  const init = () => document.querySelectorAll('[data-longlash-article]').forEach(initArticle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
